<template>
	<div class="booking-cms__benefits">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'BookingBenefits'
};
</script>

<style lang="scss" scoped>
.booking-cms__benefits {
	width: 100%;
	max-width: 740px;
	&-title {
		// text-align: center;
		margin-bottom: min(15px, 1em);
	}
}
</style>
